// axios 发送ajax请求
import request from '@/utils/request'

export default {
  // 登录
  login(account, password) {
    return request({
      url: '/login/'  + account + '/' + password,
      method: 'post'
    })
  }

}
